import { Target, ComponentType } from 'data-types-config';
import type { DynamicRouteDestinationProps } from './DynamicRouteDestination.types';

export const dynamicRouteDestinationDefaults: Partial<DynamicRouteDestinationProps> = {
  routeName: '',
  link: '',
  target: Target.Self,
  componentType: ComponentType.Internal,
  params: {},
  query: {},
  isDisabled: false,
  isVisible: true,
  text: '',
};
